module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "name": "size-modal",
      "transition": "nice-modal-fade",
      "classes": "demo-modal-class",
      "min-width": 200,
      "min-height": 200,
      "pivot-y": 0.5,
      "adaptive": true,
      "scrollable": true,
      "reset": true,
      "width": "60%",
      "height": "auto"
    },
    on: {
      "before-open": _vm.beforeOpen,
      "opened": _vm.opened,
      "closed": _vm.closed,
      "before-close": _vm.beforeClose
    }
  }, [_c('div', {
    staticClass: "size-modal-content"
  }, [_c('div', [_vm._v("A new paragraph will be added every 5 sec to show how "), _c('b', [_vm._v("height")]), _vm._v(" scales.")]), _vm._v(" "), _vm._l((_vm.paragraphs), function(p, i) {
    return _c('div', {
      key: i
    }, [_vm._v("\n      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla dictum purus egestas libero ornare venenatis.\n      Maecenas pharetra tortor eu tortor imperdiet, a faucibus quam finibus. Nulla id lacinia quam.\n      Praesent imperdiet sed magna non finibus. Aenean blandit, mauris vitae lacinia rutrum,\n      nunc mi scelerisque sem, in laoreet sem lectus ut orci. Ut egestas nulla in vehicula feugiat.\n      Vivamus tincidunt nisi vel risus dictum suscipit. Nulla id blandit mi, vulputate aliquam enim.\n    ")])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-788388bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/SizeModal.vue
// module id = 36
// module chunks = 0